exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-view thead[data-v-5dfca259]{display:table-header-group}.table-view td.state .certificate[data-v-5dfca259]{align-items:center;margin-top:5px}.info-error[data-v-5dfca259]{border:1px solid #ef0348;border-radius:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5dfca259","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Content/src/views/Orders.vue
// module id = 836
// module chunks = 1